import React, { Component } from "react";
import {  Box, HStack, Text, Spacer, Square } from '@chakra-ui/react';
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faArrowCircleDown, faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";

import LocalStorageService from "../../../../services/LocalStorageService.js";
import CoreService from "../../../../services/CoreService.js";


function getRandomColor() 
{
    var letters = '0123456789ABCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}


function getLabelMapColor(label, colorMap)
{
  var labelColor = colorMap.find((c) => c.name === label);
  var result = (labelColor) ? labelColor.id: getRandomColor();
  return result; 
}

function getLabelMapOrder(label, colorMap)
{
  var result = colorMap.findIndex((c) => c.name === label);
  return result; 
}
 


function toChartData(titleText, apiData, cmap) 
{

  const chartOptions = 
  {
    title: {
      display: true,
      text: titleText,
      fontSize: 10,
      stacked: true
    },
    responsive: true,
    sort: true,
    scales: {
      xAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true
        }
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true
        }
      }]

    }
  };


  // We need to create EVERY combination of partition property and count property and assign count and pct to these. 
  // The partitionProp is the label and the countProp makes up each bar of the stacked bar
  // We don't actually use the count, only the percentage.  
  const labels = [...new Set(apiData.map(rec => rec.partitionProp))]
  const udatasetLabels = [...new Set(apiData.map(rec => rec.countProp))]
  //const colorMap = datasetLabels.map((l) => {return {label: l, color: getRandomColor()}});
  const colorMap = Object.fromEntries(udatasetLabels.map(l => [l, getLabelMapColor(l, cmap)]));

  // sort everything by color map
  var oDatasetLabels = udatasetLabels.map((l) => {return {label: l, order: getLabelMapOrder(l, cmap)}});
  oDatasetLabels.sort((a,b) => b.order-a.order);
  var datasetLabels = oDatasetLabels.map((ol) => ol.label);

  




  var fullDataset = [];
  if (apiData.length > 0)
  {
    var partitionPropId = apiData[0].partitionPropId;
    var countPropId = apiData[0].countPropId;
    labels.forEach((label) => 
    {
      datasetLabels.forEach((dLabel) =>
      {
        var dta =  (apiData.some((d) => d.partitionProp === label && d.countProp === dLabel)) ?
              apiData.find((d) => d.partitionProp === label && d.countProp === dLabel)
             : {partitionPropId: partitionPropId, countPropId: countPropId, partitionProp: label, countProp: dLabel, count: 0, pct: 0, order: getLabelMapOrder(label, cmap)}
          fullDataset.push(dta);
      })
    })



  }

  // iterate through each grade to fill datasets
  var datasets = [];

    for (var j=0; j<datasetLabels.length; j++)
    {
      var dsetData = [];
      for (var x=0; x<fullDataset.length; x++)
      {
        if (fullDataset[x].countProp === datasetLabels[j])
        {
          dsetData.push(fullDataset[x].pct);
        }

      };
      datasets.push({stack: "key", label: datasetLabels[j], data: dsetData, backgroundColor: colorMap[datasetLabels[j]]});
    }

 
    
  return {options: chartOptions, data: {labels: labels, datasets: datasets}};
}

  // ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
  function gradeToColor(grade)
  {
    if (grade==="PREMIUM" || grade==="EXCELLENT") return '#0088fe';
    if (grade==="FANCY" || grade==="GOOD") return '#00C49F';
    if (grade==="STANDARD" || grade==="FAIR") return '#FFBB28';
    if (grade==="POOR") return '#FF8042';
    return '#D9DDE3';
  }






export default class FilteredCountPartitionStackedBarChart extends Component 
{
  constructor(props) {
    super(props);
    this.state = {
      chartOptions: [],
      chartLabels: ["Loading..."],
      chartData: null,
      isLoading: true,
      moreCaret: "caret-up",
      isCollapsed: false,
    };

    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();

    this.refreshData = this.refreshData.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  async componentDidMount() {
    if (this.props.searchParams) {
      await this.refreshData();
    }
  }

  async componentDidUpdate(prevProps, prevState) 
  {
    if (this.props.searchParamsKey != prevProps.searchParamsKey) {
      await this.refreshData();
    }
  }

  async refreshData() 
  {
    this.setState({ isLoading: true });
    var schema = this.localStorageService.getSchema(this.props.currentSchemaId);
    var apiResult = await this.coreService.fetchCountPctPartitionByPropResult(this.props.partitionProp, this.props.countProp, this.props.searchParams, schema?.search ?? {}, this.props.userSession.gcid, this.props.userSession.token);
    if (apiResult.hasError)
    {
        // TBD: we should show this in the chart box
        return;
    }
    var conformedData = toChartData("Title Text", apiResult.dataResult.data, this.props.colorMap);
    this.setState({
      chartOptions: conformedData.options,
      chartData: conformedData.data,
      isLoading: false
    });
  }

  toggleCollapse() {
    let newIsCollapsed = !this.state.isCollapsed;
    let newCaretState = newIsCollapsed ? "caret-down" : "caret-up";
    this.setState({
      isCollapsed: newIsCollapsed,
      moreCaret: newCaretState,
    });
  }



  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    return (
      <Box p='4' alignItems='center' backgroundColor={"white"} borderRadius={"5px"} w="100%" m ="3">
        <HStack>
          <Spacer/>
          <Text fontSize={{ base: '16px', md: '20px', lg: '28x' }} >{(this.props.title) ? this.props.title : "Grade Chart"}</Text>

          <Spacer />
          <FontAwesomeIcon icon={(this.state.isCollapsed) ? faArrowCircleDown : faArrowCircleUp}  onClick={() => this.toggleCollapse()} />
          {loadingIcon}
        </HStack>
          {!this.state.isCollapsed ? (

              <Square >
                {(this.state.chartData) ?
                   <Bar
                        data={this.state.chartData}
                        options={this.state.chartOptions}
                        height="100%"
                    />
                    : <Text>Loading...</Text>
                }
          
              </Square>

          ) : (
            <span />
          )}

      </Box>
    );
  }
}



